(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4795,3937],{

/***/ 84403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Curry = __webpack_require__(41386);
var Caml_option = __webpack_require__(57175);

var $$AbortController = {};

function encodeRequestMethod(method_) {
  if (typeof method_ !== "number") {
    return method_._0;
  }
  switch (method_) {
    case /* Get */0 :
        return "GET";
    case /* Head */1 :
        return "HEAD";
    case /* Post */2 :
        return "POST";
    case /* Put */3 :
        return "PUT";
    case /* Delete */4 :
        return "DELETE";
    case /* Connect */5 :
        return "CONNECT";
    case /* Options */6 :
        return "OPTIONS";
    case /* Trace */7 :
        return "TRACE";
    case /* Patch */8 :
        return "PATCH";
    
  }
}

function encodeReferrerPolicy(param) {
  switch (param) {
    case /* None */0 :
        return "";
    case /* NoReferrer */1 :
        return "no-referrer";
    case /* NoReferrerWhenDowngrade */2 :
        return "no-referrer-when-downgrade";
    case /* SameOrigin */3 :
        return "same-origin";
    case /* Origin */4 :
        return "origin";
    case /* StrictOrigin */5 :
        return "strict-origin";
    case /* OriginWhenCrossOrigin */6 :
        return "origin-when-cross-origin";
    case /* StrictOriginWhenCrossOrigin */7 :
        return "strict-origin-when-cross-origin";
    case /* UnsafeUrl */8 :
        return "unsafe-url";
    
  }
}

function encodeRequestMode(param) {
  switch (param) {
    case /* Navigate */0 :
        return "navigate";
    case /* SameOrigin */1 :
        return "same-origin";
    case /* NoCORS */2 :
        return "no-cors";
    case /* CORS */3 :
        return "cors";
    
  }
}

function encodeRequestCredentials(param) {
  switch (param) {
    case /* Omit */0 :
        return "omit";
    case /* SameOrigin */1 :
        return "same-origin";
    case /* Include */2 :
        return "include";
    
  }
}

function encodeRequestCache(param) {
  switch (param) {
    case /* Default */0 :
        return "default";
    case /* NoStore */1 :
        return "no-store";
    case /* Reload */2 :
        return "reload";
    case /* NoCache */3 :
        return "no-cache";
    case /* ForceCache */4 :
        return "force-cache";
    case /* OnlyIfCached */5 :
        return "only-if-cached";
    
  }
}

function encodeRequestRedirect(param) {
  switch (param) {
    case /* Follow */0 :
        return "follow";
    case /* Error */1 :
        return "error";
    case /* Manual */2 :
        return "manual";
    
  }
}

var HeadersInit = {};

var $$Headers = {};

var BodyInit = {};

function map(f, v) {
  if (v !== undefined) {
    return Caml_option.some(Curry._1(f, Caml_option.valFromOption(v)));
  }
  
}

function make(method_, headers, body, referrer, referrerPolicyOpt, mode, credentials, cache, redirect, integrityOpt, keepalive, signal) {
  var referrerPolicy = referrerPolicyOpt !== undefined ? referrerPolicyOpt : /* None */0;
  var integrity = integrityOpt !== undefined ? integrityOpt : "";
  var partial_arg = integrity;
  var partial_arg$1 = map(encodeRequestRedirect, redirect);
  var partial_arg$2 = map(encodeRequestCache, cache);
  var partial_arg$3 = map(encodeRequestCredentials, credentials);
  var partial_arg$4 = map(encodeRequestMode, mode);
  var partial_arg$5 = encodeReferrerPolicy(referrerPolicy);
  var partial_arg$6 = map(encodeRequestMethod, method_);
  return function (param) {
    var tmp = {};
    if (partial_arg$6 !== undefined) {
      tmp.method = partial_arg$6;
    }
    if (headers !== undefined) {
      tmp.headers = Caml_option.valFromOption(headers);
    }
    if (body !== undefined) {
      tmp.body = Caml_option.valFromOption(body);
    }
    if (referrer !== undefined) {
      tmp.referrer = referrer;
    }
    if (partial_arg$5 !== undefined) {
      tmp.referrerPolicy = partial_arg$5;
    }
    if (partial_arg$4 !== undefined) {
      tmp.mode = partial_arg$4;
    }
    if (partial_arg$3 !== undefined) {
      tmp.credentials = partial_arg$3;
    }
    if (partial_arg$2 !== undefined) {
      tmp.cache = partial_arg$2;
    }
    if (partial_arg$1 !== undefined) {
      tmp.redirect = partial_arg$1;
    }
    if (partial_arg !== undefined) {
      tmp.integrity = partial_arg;
    }
    if (keepalive !== undefined) {
      tmp.keepalive = keepalive;
    }
    if (signal !== undefined) {
      tmp.signal = Caml_option.valFromOption(signal);
    }
    return tmp;
  };
}

function method_(self) {
  var method_$1 = self.method;
  switch (method_$1) {
    case "CONNECT" :
        return /* Connect */5;
    case "DELETE" :
        return /* Delete */4;
    case "GET" :
        return /* Get */0;
    case "HEAD" :
        return /* Head */1;
    case "OPTIONS" :
        return /* Options */6;
    case "PATCH" :
        return /* Patch */8;
    case "POST" :
        return /* Post */2;
    case "PUT" :
        return /* Put */3;
    case "TRACE" :
        return /* Trace */7;
    default:
      return /* Other */{
              _0: method_$1
            };
  }
}

function type_(self) {
  var e = self.type;
  switch (e) {
    case "" :
        return /* None */0;
    case "audio" :
        return /* Audio */1;
    case "font" :
        return /* Font */2;
    case "image" :
        return /* Image */3;
    case "script" :
        return /* Script */4;
    case "style" :
        return /* Style */5;
    case "track" :
        return /* Track */6;
    case "video" :
        return /* Video */7;
    default:
      throw {
            RE_EXN_ID: "Failure",
            _1: "Unknown requestType: " + e,
            Error: new Error()
          };
  }
}

function destination(self) {
  var e = self.destination;
  switch (e) {
    case "" :
        return /* None */0;
    case "document" :
        return /* Document */1;
    case "embed" :
        return /* Embed */2;
    case "font" :
        return /* Font */3;
    case "image" :
        return /* Image */4;
    case "manifest" :
        return /* Manifest */5;
    case "media" :
        return /* Media */6;
    case "object" :
        return /* Object */7;
    case "report" :
        return /* Report */8;
    case "script" :
        return /* Script */9;
    case "serviceworker" :
        return /* ServiceWorker */10;
    case "sharedworder" :
        return /* SharedWorker */11;
    case "style" :
        return /* Style */12;
    case "worker" :
        return /* Worker */13;
    case "xslt" :
        return /* Xslt */14;
    default:
      throw {
            RE_EXN_ID: "Failure",
            _1: "Unknown requestDestination: " + e,
            Error: new Error()
          };
  }
}

function referrerPolicy(self) {
  var e = self.referrerPolicy;
  switch (e) {
    case "" :
        return /* None */0;
    case "no-referrer" :
        return /* NoReferrer */1;
    case "no-referrer-when-downgrade" :
        return /* NoReferrerWhenDowngrade */2;
    case "origin" :
        return /* Origin */4;
    case "origin-when-cross-origin" :
        return /* OriginWhenCrossOrigin */6;
    case "same-origin" :
        return /* SameOrigin */3;
    case "strict-origin" :
        return /* StrictOrigin */5;
    case "strict-origin-when-cross-origin" :
        return /* StrictOriginWhenCrossOrigin */7;
    case "unsafe-url" :
        return /* UnsafeUrl */8;
    default:
      throw {
            RE_EXN_ID: "Failure",
            _1: "Unknown referrerPolicy: " + e,
            Error: new Error()
          };
  }
}

function mode(self) {
  var e = self.mode;
  switch (e) {
    case "cors" :
        return /* CORS */3;
    case "navigate" :
        return /* Navigate */0;
    case "no-cors" :
        return /* NoCORS */2;
    case "same-origin" :
        return /* SameOrigin */1;
    default:
      throw {
            RE_EXN_ID: "Failure",
            _1: "Unknown requestMode: " + e,
            Error: new Error()
          };
  }
}

function credentials(self) {
  var e = self.credentials;
  switch (e) {
    case "include" :
        return /* Include */2;
    case "omit" :
        return /* Omit */0;
    case "same-origin" :
        return /* SameOrigin */1;
    default:
      throw {
            RE_EXN_ID: "Failure",
            _1: "Unknown requestCredentials: " + e,
            Error: new Error()
          };
  }
}

function cache(self) {
  var e = self.cache;
  switch (e) {
    case "default" :
        return /* Default */0;
    case "force-cache" :
        return /* ForceCache */4;
    case "no-cache" :
        return /* NoCache */3;
    case "no-store" :
        return /* NoStore */1;
    case "only-if-cached" :
        return /* OnlyIfCached */5;
    case "reload" :
        return /* Reload */2;
    default:
      throw {
            RE_EXN_ID: "Failure",
            _1: "Unknown requestCache: " + e,
            Error: new Error()
          };
  }
}

function redirect(self) {
  var e = self.redirect;
  switch (e) {
    case "error" :
        return /* Error */1;
    case "follow" :
        return /* Follow */0;
    case "manual" :
        return /* Manual */2;
    default:
      throw {
            RE_EXN_ID: "Failure",
            _1: "Unknown requestRedirect: " + e,
            Error: new Error()
          };
  }
}

var $$Request = {
  method_: method_,
  type_: type_,
  destination: destination,
  referrerPolicy: referrerPolicy,
  mode: mode,
  credentials: credentials,
  cache: cache,
  redirect: redirect
};

var $$Response = {};

function classify(t) {
  if (typeof t === "string") {
    return {
            NAME: "String",
            VAL: t
          };
  } else {
    return {
            NAME: "File",
            VAL: t
          };
  }
}

var EntryValue = {
  classify: classify
};

var $$FormData = {
  EntryValue: EntryValue,
  Iterator: undefined
};

var Body = {};

var RequestInit = {
  make: make
};

exports.$$AbortController = $$AbortController;
exports.HeadersInit = HeadersInit;
exports.$$Headers = $$Headers;
exports.BodyInit = BodyInit;
exports.Body = Body;
exports.RequestInit = RequestInit;
exports.$$Request = $$Request;
exports.$$Response = $$Response;
exports.$$FormData = $$FormData;
/* No side effect */


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 8416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__ParentNode = __webpack_require__(74403);
var Webapi__Dom__EventTarget = __webpack_require__(65343);
var Webapi__Dom__NonElementParentNode = __webpack_require__(82237);

function Impl(T) {
  var asHtmlDocument = (function(document) {
      var defaultView = document.defaultView;

      if (defaultView != null) {
        var HTMLDocument = defaultView.HTMLDocument;

        if (HTMLDocument != null && document instanceof HTMLDocument) {
          return document;
        }
      }
    });
  var ofNode = function (node) {
    if (Webapi__Dom__Node.nodeType(node) === /* Document */8) {
      return Caml_option.some(node);
    }
    
  };
  var compatMode = function (self) {
    return Webapi__Dom__Types.decodeCompatMode(self.compatMode);
  };
  var visibilityState = function (self) {
    return Webapi__Dom__Types.decodeVisibilityState(self.visibilityState);
  };
  return {
          asHtmlDocument: asHtmlDocument,
          ofNode: ofNode,
          compatMode: compatMode,
          visibilityState: visibilityState
        };
}

var include = Webapi__Dom__Node.Impl({});

Webapi__Dom__EventTarget.Impl({});

Webapi__Dom__NonElementParentNode.Impl({});

Webapi__Dom__ParentNode.Impl({});

var asHtmlDocument = (function(document) {
      var defaultView = document.defaultView;

      if (defaultView != null) {
        var HTMLDocument = defaultView.HTMLDocument;

        if (HTMLDocument != null && document instanceof HTMLDocument) {
          return document;
        }
      }
    });

function ofNode(node) {
  if (Webapi__Dom__Node.nodeType(node) === /* Document */8) {
    return Caml_option.some(node);
  }
  
}

function compatMode(self) {
  return Webapi__Dom__Types.decodeCompatMode(self.compatMode);
}

function visibilityState(self) {
  return Webapi__Dom__Types.decodeVisibilityState(self.visibilityState);
}

var nodeType = include.nodeType;

exports.Impl = Impl;
exports.nodeType = nodeType;
exports.asHtmlDocument = asHtmlDocument;
exports.ofNode = ofNode;
exports.compatMode = compatMode;
exports.visibilityState = visibilityState;
/* include Not a pure module */


/***/ }),

/***/ 65343:
/***/ (function(__unused_webpack_module, exports) {

"use strict";



function Impl(T) {
  return {};
}

exports.Impl = Impl;
/* No side effect */


/***/ }),

/***/ 98727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__EventTarget = __webpack_require__(65343);

function Impl(T) {
  var nodeType = function (self) {
    return Webapi__Dom__Types.decodeNodeType(self.nodeType);
  };
  return {
          nodeType: nodeType
        };
}

Webapi__Dom__EventTarget.Impl({});

function nodeType(self) {
  return Webapi__Dom__Types.decodeNodeType(self.nodeType);
}

exports.Impl = Impl;
exports.nodeType = nodeType;
/*  Not a pure module */


/***/ }),

/***/ 82237:
/***/ (function(__unused_webpack_module, exports) {

"use strict";



function Impl(T) {
  return {};
}

exports.Impl = Impl;
/* No side effect */


/***/ }),

/***/ 74403:
/***/ (function(__unused_webpack_module, exports) {

"use strict";



function Impl(T) {
  return {};
}

exports.Impl = Impl;
/* No side effect */


/***/ }),

/***/ 97088:
/***/ (function(__unused_webpack_module, exports) {

"use strict";



function encodeCompareHow(x) {
  return x;
}

function decodeCompareResult(x) {
  if ((x + 1 >>> 0) > 2) {
    return /* Unknown */3;
  } else {
    return x + 1 | 0;
  }
}

function decodeCompatMode(x) {
  switch (x) {
    case "BackCompat" :
        return /* BackCompat */0;
    case "CSS1Compat" :
        return /* CSS1Compat */1;
    default:
      return /* Unknown */2;
  }
}

function encodeContentEditable(x) {
  switch (x) {
    case /* True */0 :
        return "true";
    case /* False */1 :
        return "false";
    case /* Inherit */2 :
        return "inherit";
    case /* Unknown */3 :
        return "";
    
  }
}

function decodeContentEditable(x) {
  switch (x) {
    case "false" :
        return /* False */1;
    case "inherit" :
        return /* Inherit */2;
    case "true" :
        return /* True */0;
    default:
      return /* Unknown */3;
  }
}

function decodeDeltaMode(x) {
  if (x > 2 || x < 0) {
    throw {
          RE_EXN_ID: "Invalid_argument",
          _1: "invalid deltaMode",
          Error: new Error()
        };
  }
  return x;
}

function encodeDesignMode(x) {
  switch (x) {
    case /* On */0 :
        return "on";
    case /* Off */1 :
        return "off";
    case /* Unknown */2 :
        return "";
    
  }
}

function decodeDesignMode(x) {
  switch (x) {
    case "off" :
        return /* Off */1;
    case "on" :
        return /* On */0;
    default:
      return /* Unknown */2;
  }
}

function encodeDir(x) {
  switch (x) {
    case /* Ltr */0 :
        return "ltr";
    case /* Rtl */1 :
        return "rtl";
    case /* Unknown */2 :
        return "";
    
  }
}

function decodeDir(x) {
  switch (x) {
    case "ltr" :
        return /* Ltr */0;
    case "rtl" :
        return /* Rtl */1;
    default:
      return /* Unknown */2;
  }
}

function decode(x) {
  if (x > 3 || x < 0) {
    return /* Unknown */4;
  } else {
    return x;
  }
}

var EventPhase = {
  decode: decode
};

function encodeFilterAction(x) {
  return x + 1 | 0;
}

function encodeInsertPosition(x) {
  switch (x) {
    case /* BeforeBegin */0 :
        return "beforebegin";
    case /* AfterBegin */1 :
        return "afterbegin";
    case /* BeforeEnd */2 :
        return "beforeend";
    case /* AfterEnd */3 :
        return "afterend";
    
  }
}

function encodeModifierKey(x) {
  switch (x) {
    case /* Alt */0 :
        return "Alt";
    case /* AltGraph */1 :
        return "AltGraph";
    case /* CapsLock */2 :
        return "CapsLock";
    case /* Control */3 :
        return "Control";
    case /* Fn */4 :
        return "Fn";
    case /* FnLock */5 :
        return "FnLock";
    case /* Hyper */6 :
        return "Hyper";
    case /* Meta */7 :
        return "Meta";
    case /* NumLock */8 :
        return "NumLock";
    case /* ScrollLock */9 :
        return "ScrollLock";
    case /* Shift */10 :
        return "Shift";
    case /* Super */11 :
        return "Super";
    case /* Symbol */12 :
        return "Symbol";
    case /* SymbolLock */13 :
        return "SymbolLock";
    
  }
}

function decodeNodeType(x) {
  if (x > 12 || x < 1) {
    return /* Unknown */12;
  } else {
    return x - 1 | 0;
  }
}

function decodePointerType(x) {
  switch (x) {
    case "mouse" :
        return /* Mouse */0;
    case "pen" :
        return /* Pen */1;
    case "touch|" :
        return /* Touch */2;
    default:
      return /* Unknown */3;
  }
}

function decodeReadyState(x) {
  switch (x) {
    case "complete" :
        return /* Complete */2;
    case "interactive" :
        return /* Interactive */1;
    case "loading" :
        return /* Loading */0;
    default:
      return /* Unknown */3;
  }
}

function decodeShadowRootMode(x) {
  switch (x) {
    case "closed" :
        return /* Closed */1;
    case "open" :
        return /* Open */0;
    default:
      throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Unknown shadowRootMode",
            Error: new Error()
          };
  }
}

function decodeVisibilityState(x) {
  switch (x) {
    case "hidden" :
        return /* Hidden */1;
    case "prerender" :
        return /* Prerender */2;
    case "unloaded" :
        return /* Unloaded */3;
    case "visible" :
        return /* Visible */0;
    default:
      return /* Unknown */4;
  }
}

function many(x) {
  if (x) {
    return x.hd | many(x.tl);
  } else {
    return 0;
  }
}

var WhatToShow = {
  _All: -1,
  _Element: 1,
  _Attribute: 2,
  _Text: 4,
  _CDATASection: 8,
  _EntityReference: 16,
  _Entity: 32,
  _ProcessingInstruction: 64,
  _Comment: 128,
  _Document: 256,
  _DocumentType: 512,
  _DocumentFragment: 1024,
  _Notation: 2048,
  many: many
};

exports.encodeCompareHow = encodeCompareHow;
exports.decodeCompareResult = decodeCompareResult;
exports.decodeCompatMode = decodeCompatMode;
exports.encodeContentEditable = encodeContentEditable;
exports.decodeContentEditable = decodeContentEditable;
exports.decodeDeltaMode = decodeDeltaMode;
exports.encodeDesignMode = encodeDesignMode;
exports.decodeDesignMode = decodeDesignMode;
exports.encodeDir = encodeDir;
exports.decodeDir = decodeDir;
exports.EventPhase = EventPhase;
exports.encodeFilterAction = encodeFilterAction;
exports.encodeInsertPosition = encodeInsertPosition;
exports.encodeModifierKey = encodeModifierKey;
exports.decodeNodeType = decodeNodeType;
exports.decodePointerType = decodePointerType;
exports.decodeReadyState = decodeReadyState;
exports.decodeShadowRootMode = decodeShadowRootMode;
exports.decodeVisibilityState = decodeVisibilityState;
exports.WhatToShow = WhatToShow;
/* No side effect */


/***/ }),

/***/ 27236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Caml_obj = __webpack_require__(14923);

function init_mod(loc, shape) {
  var undef_module = function (param) {
    throw {
          RE_EXN_ID: "Undefined_recursive_module",
          _1: loc,
          Error: new Error()
        };
  };
  var loop = function (shape, struct_, idx) {
    if (typeof shape === "number") {
      switch (shape) {
        case /* Function */0 :
            struct_[idx] = undef_module;
            return ;
        case /* Lazy */1 :
            struct_[idx] = {
              LAZY_DONE: true,
              VAL: undef_module
            };
            return ;
        case /* Class */2 :
            struct_[idx] = [
              undef_module,
              undef_module,
              undef_module,
              0
            ];
            return ;
        
      }
    } else {
      if (shape.TAG === /* Module */0) {
        var comps = shape._0;
        var v = {};
        struct_[idx] = v;
        var len = comps.length;
        for(var i = 0; i < len; ++i){
          var match = comps[i];
          loop(match[0], v, match[1]);
        }
        return ;
      }
      struct_[idx] = shape._0;
      return ;
    }
  };
  var res = {};
  var dummy_name = "dummy";
  loop(shape, res, dummy_name);
  return res[dummy_name];
}

function update_mod(shape, o, n) {
  var aux = function (shape, o, n, parent, i) {
    if (typeof shape === "number") {
      switch (shape) {
        case /* Function */0 :
            parent[i] = n;
            return ;
        case /* Lazy */1 :
        case /* Class */2 :
            return Caml_obj.update_dummy(o, n);
        
      }
    } else {
      if (shape.TAG !== /* Module */0) {
        return ;
      }
      var comps = shape._0;
      for(var i$1 = 0 ,i_finish = comps.length; i$1 < i_finish; ++i$1){
        var match = comps[i$1];
        var name = match[1];
        aux(match[0], o[name], n[name], o, name);
      }
      return ;
    }
  };
  if (typeof shape === "number") {
    throw {
          RE_EXN_ID: "Assert_failure",
          _1: [
            "caml_module.ml",
            107,
            10
          ],
          Error: new Error()
        };
  }
  if (shape.TAG === /* Module */0) {
    var comps = shape._0;
    for(var i = 0 ,i_finish = comps.length; i < i_finish; ++i){
      var match = comps[i];
      var name = match[1];
      aux(match[0], o[name], n[name], o, name);
    }
    return ;
  }
  throw {
        RE_EXN_ID: "Assert_failure",
        _1: [
          "caml_module.ml",
          107,
          10
        ],
        Error: new Error()
      };
}

exports.init_mod = init_mod;
exports.update_mod = update_mod;
/* No side effect */


/***/ })

}]);